module.exports = __webpack_public_path__ + "img/NGC.a3e27e18.svg";